export type BankingRegionVariant = 'GB' | 'US' | 'EUR';

export interface BankingRegion {
  /** ISO 3166-1 alpha-2 country code (upper-case). */
  iso: string;
  /** Human-readable country label. */
  label: string;
  /** Emoji flag, used for UX only. */
  flag: string;
  /** Corridor variant that decides validation / payload rules. */
  variant: BankingRegionVariant;
  /** Settlement currency for this corridor. */
  currency: 'GBP' | 'USD' | 'EUR';
}

/** Featured regions first, then the euro-area SEPA countries. */
export const BANKING_REGIONS: readonly BankingRegion[] = [
  { iso: 'GB', label: 'United Kingdom', flag: '🇬🇧', variant: 'GB', currency: 'GBP' },
  { iso: 'US', label: 'United States', flag: '🇺🇸', variant: 'US', currency: 'USD' },
  { iso: 'IE', label: 'Ireland', flag: '🇮🇪', variant: 'EUR', currency: 'EUR' },
  { iso: 'AT', label: 'Austria', flag: '🇦🇹', variant: 'EUR', currency: 'EUR' },
  { iso: 'BE', label: 'Belgium', flag: '🇧🇪', variant: 'EUR', currency: 'EUR' },
  { iso: 'HR', label: 'Croatia', flag: '🇭🇷', variant: 'EUR', currency: 'EUR' },
  { iso: 'CY', label: 'Cyprus', flag: '🇨🇾', variant: 'EUR', currency: 'EUR' },
  { iso: 'EE', label: 'Estonia', flag: '🇪🇪', variant: 'EUR', currency: 'EUR' },
  { iso: 'FI', label: 'Finland', flag: '🇫🇮', variant: 'EUR', currency: 'EUR' },
  { iso: 'FR', label: 'France', flag: '🇫🇷', variant: 'EUR', currency: 'EUR' },
  { iso: 'DE', label: 'Germany', flag: '🇩🇪', variant: 'EUR', currency: 'EUR' },
  { iso: 'GR', label: 'Greece', flag: '🇬🇷', variant: 'EUR', currency: 'EUR' },
  { iso: 'IT', label: 'Italy', flag: '🇮🇹', variant: 'EUR', currency: 'EUR' },
  { iso: 'LV', label: 'Latvia', flag: '🇱🇻', variant: 'EUR', currency: 'EUR' },
  { iso: 'LT', label: 'Lithuania', flag: '🇱🇹', variant: 'EUR', currency: 'EUR' },
  { iso: 'LU', label: 'Luxembourg', flag: '🇱🇺', variant: 'EUR', currency: 'EUR' },
  { iso: 'MT', label: 'Malta', flag: '🇲🇹', variant: 'EUR', currency: 'EUR' },
  { iso: 'NL', label: 'Netherlands', flag: '🇳🇱', variant: 'EUR', currency: 'EUR' },
  { iso: 'PT', label: 'Portugal', flag: '🇵🇹', variant: 'EUR', currency: 'EUR' },
  { iso: 'SK', label: 'Slovakia', flag: '🇸🇰', variant: 'EUR', currency: 'EUR' },
  { iso: 'SI', label: 'Slovenia', flag: '🇸🇮', variant: 'EUR', currency: 'EUR' },
  { iso: 'ES', label: 'Spain', flag: '🇪🇸', variant: 'EUR', currency: 'EUR' },
] as const;

export function regionForIso(iso: string | undefined | null): BankingRegion | null {
  if (!iso) return null;
  const upper = iso.toUpperCase();
  return BANKING_REGIONS.find((r) => r.iso === upper) ?? null;
}

